import React from 'react'

import { observer } from 'mobx-react-lite'

import { MaterialsAndDeliveries } from 'vendor/components/MaterialsAndDeliveries/materials_and_deliveries'
import { usePublicVendorStores } from 'vendor/hooks/use-public-stores'

export const Materials = observer(() => {
  const { orderStore, uploaderStore, deliveryStore, unitsStore } = usePublicVendorStores()

  return (
    <MaterialsAndDeliveries
      units={unitsStore.units}
      order={orderStore.selectedOrder}
      onSetOrderDirty={(isDirty) => (orderStore.selectedOrderDirty = isDirty)}
      orderMaterialSummary={orderStore.orderMaterialSummary}
      updateDelivery={deliveryStore.updateDelivery}
      addExistingFiles={uploaderStore.addExistingFiles}
      fileList={uploaderStore.fileList}
      deliveryTotalCost={orderStore.deliveryTotalCost}
      materialsCount={orderStore.materialsCount}
      getOrderMaterialsByDeliveryId={orderStore.getOrderMaterialsByDeliveryId}
      updateOrderMaterialsByDeliveryId={orderStore.updateOrderMaterialsByDeliveryId}
    />
  )
})
